import $ from 'jquery'
import 'owl.carousel';
import { trace } from 'rytm-helpers';

const OWL_SELECTOR = ".wj-carousel"

const destroyOwlCarousel = (el) => {
  let $carousel = $(el)
  if ($carousel.length > 0) {
    $carousel.trigger('destroy.owl.carousel').removeClass('owl-carousel owl-loaded')
    $carousel.find('.owl-stage-outer').children().unwrap()
  }
}

const refreshOwlCarousel = (el, params) => {
  destroyOwlCarousel(el)
  initOwlCarousel(el, params)
}

const initOwlCarousel = (el, params) => {    
  let c = null
  let $carousel = $(el)
  if ($carousel.length > 0) {
    $carousel.addClass('owl-carousel')
    c = $carousel.owlCarousel(params)
  }
  return c
}

const getOwlParams = (el) => {
  const num = el.dataset.elements ? parseInt(el.dataset.elements) : 1
  const numSm = el.dataset.elementsSm ? parseInt(el.dataset.elementsSm) : 1
  const numMd = el.dataset.elementsMd ? parseInt(el.dataset.elementsMd) : 1
  const autorotate = el.dataset.autorotate ? (el.dataset.autorotate == "true") : false
  return {
    nav: true,
    navText: [
      '<div><svg xmlns="http://www.w3.org/2000/svg" overflow="visible" viewBox="0 0 32 21"><path d="M9.959 20.584a1.537 1.537 0 002.104 0 1.372 1.372 0 000-2.006L5.08 11.919h25.432c.822 0 1.488-.636 1.488-1.419 0-.784-.666-1.419-1.488-1.419H5.08l6.982-6.659a1.372 1.372 0 000-2.006A1.52 1.52 0 0011.011 0c-.381 0-.763.139-1.052.416L.436 9.497a1.372 1.372 0 000 2.006l9.523 9.081z"/></svg><span class="sr-only">Wstecz / Previous</span></div>', 
      '<div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -1 33 22" overflow="visible"><path d="M31.564 9.498L22.041.417a1.537 1.537 0 00-2.104 0 1.37 1.37 0 000 2.006l6.981 6.659H1.488C.666 9.082 0 9.717 0 10.5c0 .784.666 1.419 1.488 1.419H26.92l-6.982 6.659a1.374 1.374 0 000 2.006c.291.278.669.416 1.05.416.382 0 .764-.139 1.053-.416l9.523-9.081a1.37 1.37 0 000-2.005"/></svg><span class="sr-only">Dalej / Next</span></div>'
    ],
    loop: autorotate,
    margin: 0,
    center: false,
    dots: false,
    autoplay: autorotate,
    autoplayTimeout: 2000,
    autoplaySpeed: 1000,
    responsive: {
      0: {
        items: 1,
      },
      576: {
        items: numSm,
      },
      768: {
        items: numMd,
      },
      992: {
        items: num,
      },
    }
  }
}

const getOwlCarousels = () => {
  return [...document.querySelectorAll(OWL_SELECTOR)]
}

export const initOwlCarousels = () => {
  trace("Init owl carousel")
  let c = null
  const list = getOwlCarousels()
  list.forEach((el) => {
    c = initOwlCarousel(el, getOwlParams(el))
  })
  return c
}
export const destroyOwlCarousels = () => {
  trace("Destroy owl carousel")
  const list = getOwlCarousels()
  list.forEach((el) => {
    destroyOwlCarousel(el)
  })
}
export const refreshOwlCarousels = () => {
  const list = getOwlCarousels()
  list.forEach((el) => {
    refreshOwlCarousel(el, getOwlParams(el))
  })
}